import { createSlice } from "@reduxjs/toolkit";

export const searchBarSlice = createSlice({
    name: 'searchBar',
    initialState: {
        searchMode: '',
        searchTerm: '',
        searchTarget: '',
        searchTargetOptions: [],
        filters: [],
        loadingSearch: false,
        failedToLoadSearch: false
    },
    reducers: {
        changeSearchMode: (state, action) => {
            return {
                ...state,
                searchMode: action.payload
            }
        },
        changeSearchTerm: (state, action) => {
            return {
                ...state,
                searchTerm: action.payload
            }
        },
        changeSearchTarget: (state, action) => {
            return {
                ...state,
                searchTarget: action.payload
            }
        },
        changeSearchTargetOptions: (state, action) => {
            return {
                ...state,
                searchTargetOptions: action.payload
            }
        },
        createFilter: (state, action) => {
            state.filters.push(action.payload)
        },
        changeFilterActive: (state, action) => {
            const newFilters = state.filters.map(filter => {
                if (filter.id === action.payload) {
                    return {
                        ...filter,
                        active: !filter.active
                    }
                } else {
                    return filter
                }
            })
            return {
                ...state,
                filters: newFilters
            }
        },
        deleteFilter: (state, action) => {
            const newFilters = state.filters.filter(filter => filter.id !== action.payload);
            return {
                ...state,
                filters: newFilters
            }
        }
    }
})

export const selectSearchMode = (state) => state.searchBar.searchMode;
export const selectSearchTerm = (state) => state.searchBar.searchTerm;
export const selectSearchTarget = (state) => state.searchBar.searchTarget;
export const selectSearchTargetOptions = (state) => state.searchBar.searchTargetOptions;
export const selectFilters = (state) => state.searchBar.filters;

export const {
    changeSearchMode,
    changeSearchTerm,
    changeSearchTarget,
    changeSearchTargetOptions,
    createFilter,
    changeFilterActive,
    deleteFilter
} = searchBarSlice.actions;

export default searchBarSlice.reducer;